import { jsxs as N, jsx as o } from "react/jsx-runtime";
import { c as p } from "./Section-DOeCOW54.js";
import { useRef as h, useState as M, useEffect as a, useCallback as P } from "react";
const e = {
  "multi-range-slider": "elo-multi-range-slider",
  "multi-range-slider__track": "elo-multi-range-slider__track",
  "multi-range-slider__range": "elo-multi-range-slider__range",
  "multi-range-slider__thumb": "elo-multi-range-slider__thumb",
  "multi-range-slider__thumb--zindex-3": "elo-multi-range-slider__thumb--zindex-3",
  "multi-range-slider__thumb--zindex-4": "elo-multi-range-slider__thumb--zindex-4",
  "multi-range-slider__thumb--zindex-5": "elo-multi-range-slider__thumb--zindex-5"
}, $ = ({
  min: n,
  max: g,
  step: b,
  onChange: d,
  defaultValue: m,
  value: r,
  ...y
}) => {
  const x = h(null), u = h(null), c = h(null), [s, f] = M((r == null ? void 0 : r.min) ?? (m == null ? void 0 : m.min) ?? n), [l, z] = M((r == null ? void 0 : r.max) ?? (m == null ? void 0 : m.max) ?? g);
  a(() => {
    (r == null ? void 0 : r.max) !== void 0 && z(r.max), (r == null ? void 0 : r.min) !== void 0 && f(r.min);
  }, [r == null ? void 0 : r.max, r == null ? void 0 : r.min]);
  const _ = P(
    (t) => Math.round((t - n) / (g - n) * 100),
    [n, g]
  );
  return a(() => {
    if (u.current) {
      const t = _(s), i = _(+u.current.value);
      c.current && (c.current.style.left = `${t}%`, c.current.style.width = `${i - t}%`);
    }
  }, [s, _]), a(() => {
    if (x.current) {
      const t = _(+x.current.value), i = _(l);
      c.current && (c.current.style.width = `${i - t}%`);
    }
  }, [l, _]), a(() => {
    d == null || d({ min: s, max: l });
  }, [s, l, d]), /* @__PURE__ */ N("div", { className: e["multi-range-slider"], ...y, children: [
    /* @__PURE__ */ o(
      "input",
      {
        type: "range",
        min: n,
        max: g,
        step: b,
        value: s,
        ref: x,
        onChange: (t) => {
          const i = Math.min(+t.target.value, l - 1);
          f(i), t.target.value = i.toString();
        },
        className: p(
          e["multi-range-slider__thumb"],
          e["multi-range-slider__thumb--zindex-3"],
          {
            [e["multi-range-slider__thumb--zindex-5"]]: s > n
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      "input",
      {
        type: "range",
        min: n,
        max: g,
        step: b,
        value: l,
        ref: u,
        onChange: (t) => {
          const i = Math.max(+t.target.value, s + 1);
          z(i), t.target.value = i.toString();
        },
        className: p(
          e["multi-range-slider__thumb"],
          e["multi-range-slider__thumb--zindex-4"]
        )
      }
    ),
    /* @__PURE__ */ o("div", { className: e["multi-range-slider__track"] }),
    /* @__PURE__ */ o("div", { ref: c, className: e["multi-range-slider__range"] })
  ] });
};
export {
  $ as M
};
